// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__M_kxB","options":"AnswerScale_options__1i9sn","selected":"AnswerScale_selected__kTV6t"};